export const state = {
    windowWidth: null,
    xxl: false,
    xl: false,
    lg: false,
    md: false,
    sm: false,
    xm: false,
    isMobile: false,
    isTablet: false,
    isPhone: false,
}

export const mutations = {
    SET_WINDOW_WIDTH(state, payload) {
        state.windowWidth = payload
        
        state.xxl = payload >= 1400;
        state.xl = payload < 1400;
        state.lg = payload < 1200;
        state.md = payload < 992;
        state.sm = payload < 768;
        state.xm = payload < 576;

        state.isMobile = payload < 992; //md
        state.isTablet = payload < 768; //sm
        state.isPhone = payload < 576; //xs
    },

}

export const getters = {
    getWindowWidth(state) {
        return state.windowWidth
    },
    getIsMobile(state) {
        return state.isMobile
    },
    getIsTablet(state) {
        return state.isTablet
    },
    getIsPhone(state) {
        return state.isPhone
    },
}

export const actions = {
    changeWindowWidth({ commit }, payload) {
        commit('SET_WINDOW_WIDTH', payload)
    },
}
